<template>
    <div class="flex">
        <radial-progress-bar 
        :diameter="110"
        :strokeWidth="7"
        :completed-steps="this.percentage"
        :total-steps="100"
        :innerStrokeColor="'rgba(238, 237, 237)'"
        :timingFunc="'ease-out'"
        :startColor="this.skill.color"
        :stopColor="this.skill.secondaryColor">
            <img :src="'../../../static/media/'+skill.name+'.png'" :alt="skill.name">
        </radial-progress-bar>
    </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: "SkillGraph",
  components: {
      RadialProgressBar
  },
  props: ["skill"],
  data () {
    return {
        percentage: 0,
        item: []
    }
  },
  methods: {},
  mounted () {
    setTimeout( () => { this.$data.percentage = this.$props.skill.percentage; }, 100);
  }
};
</script>

<style scoped>
.flex {
    display: flex;
    align-items: center;
    justify-content: center;
}

img {
  height: 50px;
  width: 50px;
}



</style>



// WEBPACK FOOTER //
// src/components/children/SkillGraph.vue